import { Header } from '../../components/Shared/NavBar/Header.jsx';
import { Suggestions } from '../../components/Suggestions/Suggestions.jsx';
export const SuggestionsView = () => {
  return (
    <>
      <Header />
      <Suggestions/>
    </>
  );
};
